import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Stack,
  InputLabel,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Card,
  CardContent,
  ButtonGroup,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import { IncuranceActions } from "../../service/insurance.actions";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileSaver from "file-saver";
import Loading from "../common/Loading";
import EditIcon from "@mui/icons-material/Edit";
import "../../../../App.css";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { useTranslation } from "react-i18next";
import CustomLoader from "../../../../util/component/CustomLoader";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { GenericTitleHeader } from "../common/GenericTitleHeader";
import { ConfirmationModalTransportator } from "../transportator/ConfirmationModalTransportator";
import { transformationActions } from "../../service/transformation.action";
import { CreateVehicleAttachment } from "./createorEditVehicleAttachment";
import { attachmentsVehicleActions } from "../../service/attachmentsVehicle.action";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EmptyState from "../../../../util/component/EmptyState";
import dayjs from "dayjs";
import EmptyStateGrid from "../common/EmptyStateGrid";
import { type } from "os";
import mime from "mime";
import { FileTextWithIcon } from "../common/FileTextWithIcon";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

const AttachmentsVehicle = (props: any) => {
  let tenant = props.tenant;
  let vehicleId = props.id;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [refresh, setRefreshPage] = useState<boolean>(false);
  const [getIncreaseId, setGetIncreaseId] = useState<any>();
  const [openCreatModal, setOpenCreatModal] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [length, setLength] = useState<number>(1);
  const [message, setMessage] = useState<any>();
  const [vehicleAttachment, setVehicleAttachment] = useState<any>({
    attachment: "",
    notes: "",
    id: "",
    name: "",
  });
  const [resetForm, setResetForm] = useState<boolean>(false);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [gridApi, setGridApi] = useState<any>(null);
  const { t } = useTranslation(["operation"]);
  const { setLoading } = useContext(ContextOperation);
  const navigate = useNavigate();
  const columnsDefs: any = [
    {
      field: "filename",
      headerName: t("attachmentsvehicle.attachment"),
      flex: 1.5,
      cellRenderer(params: any) {
        return (
          <FileTextWithIcon
            onDownloadFile={() => {
              exportAttachmentVehicleById(params.data.id);
            }}
            fileTextDownload={params.data.filename}
          ></FileTextWithIcon>
        );
      },
    },
    {
      field: "notes",
      headerName: t("attachmentsvehicle.description"),
      flex: 1.5,
      cellRenderer(params: any) {
        return (
          <Tooltip title={params.data.notes}>
            <Box>{params.data.notes}</Box>
          </Tooltip>
        );
      },
    },
    {
      field: "uploadDatetime ",
      headerName: t("attachmentsvehicle.uploadDate"),
      flex: 1,
      cellRenderer: (params: any) => {
        return (
          <Box component="span">
            {dayjs(`${params.data.uploadDatetime}`).format(
              "DD/MM/YYYY -HH:mm"
            )}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "",
      maxWidth: 80,
      cellStyle: {
        padding: "0px",
        border: "none",
      },
      cellRenderer(params: any) {
        return (
          <Stack
            width="inherit"
            height="inherit"
            alignItems="center"
            alignContent="center"
            direction="row"
            bgcolor={"#f5f5f5"}
            sx={{ flexGrow: 1 }}
          >
            <ButtonGroup>
              <Tooltip title={t("tooltipTitle.edit")}>
                <IconButton
                  color="accent"
                  onClick={() => openEditModal(params)}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Box>
                <Tooltip title={t("tooltipTitle.delete")}>
                  <IconButton
                    onClick={() => openModalFunction(params)}
                    color="accent"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </ButtonGroup>
          </Stack>
        );
      },
    },
  ];
  const openEditModal = (params: any) => {
    setVehicleAttachment({
      notes: params.data.notes,
      uploadDate: params.data.uploadDate,
      id: params.data.id,
      name: params.data.filename,
    });
    setOpenCreatModal(true);
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };
  function managerData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        filename: element.filename,
        uploadDatetime: element.uploadDatetime,
        notes: element.notes,
        id: element.id,
      };
      rows.push(row);
    });
    return rows;
  }

  const getVehicleAttachmentById = () => {
    setLoading(true);
    return {
      getRows: async (params: any) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;
        attachmentsVehicleActions()
          .vehicleAttachmentById(tenant, vehicleId, pageNumber, pageSize)
          .then((response: any) => {
            params.successCallback(
              managerData(response),
              response.data.totalElements
            );
            if (response.data.totalElements) {
              setResetForm(true);
            }
            setLength(response.data.totalElements);

            setLoading(false);
          })
          .catch((error: any) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.msg,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setLoading(false);
            } else {
              setLoading(false);
            }
          });
        //setResetForm(false);
      },
    };
  };
  function exportAttachmentVehicleById(id: any) {
    setLoading(true);
    attachmentsVehicleActions()
      .downloadFileAttachment(tenant, id)
      .then((response) => {
        setLoading(false);
        const filename =
          response?.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], { type: "image" });
        FileSaver.saveAs(blob, filename);
      });
  }

  function exportAttachmentVehicle() {
    setLoading(true);
    attachmentsVehicleActions()
      .exportData(tenant, vehicleId)
      .then((response) => {
        setLoading(false);
        const filename =
          response?.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  }
  const openModalFunction = (params: any) => {
    setOpenModal(true);
    setGetIncreaseId(params.data.id);
    setMessage(
      t("attachmentsvehicle.deteteAttachment.confirmMessage").replace(
        "#textElement",
        params.data.filename || ""
      )
    );
  };
  const deleteAttachmentVehicle = () => {
    setLoading(true);
    attachmentsVehicleActions()
      .deleteAttachmentVehicle(tenant, getIncreaseId)
      .then((response: any) => {
        setLoading(false);
        setShowPopup(true);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t(
                "attachmentsvehicle.deteteAttachment.deleteSuccessMessage"
              ),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        setRefreshPage(!refresh);
      })
      .catch((error: any) => {
        setLoading(false);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: error.response.data.msg,
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };
  const createorEditVehicleAttachment = (vehicleAttachm: any) => {
    if (vehicleAttachment.id) {
      editAttachmentVehicle(vehicleAttachm.id, vehicleAttachm);
    } else {
      createAttachmentVehicle(
        vehicleAttachm.id,
        vehicleAttachm.description,
        vehicleAttachm.file
      );
    }
  };
  const editAttachmentVehicle = (id: any, description: any) => {
    setLoading(true);
    attachmentsVehicleActions()
      .updateAttachmentVehicle(tenant, id, description)
      .then((resonse: any) => {
        setLoading(false);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t(
                "attachmentsvehicle.createAttachment.editSuccessMessage"
              ),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        setRefreshPage(!refresh);
      })
      .catch((error: any) => {
        setLoading(false);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: error.response.data.msg,
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };

  const createAttachmentVehicle = (id: any, description: any, file: any) => {
    setLoading(true);
    attachmentsVehicleActions()
      .createAttachmentVehicle(tenant, id, description, file)
      .then((resonse: any) => {
        setLoading(false);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t(
                "attachmentsvehicle.createAttachment.createdSuccessMessage"
              ),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        setLength(1);
        setRefreshPage(!refresh);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.response.status === 409) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("attachmentsvehicle.createAttachment.409Error"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        } else {
          setLoading(false);
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: error.response.data.msg,
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        }
      });
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(getVehicleAttachmentById());
    }
  }, [gridApi, refresh]);

  console.log(length, "lenght");
  return (
    <>
        <SectionHeader
            title={t("attachmentsvehicle.titleFirst") + " " + t("attachmentsvehicle.titleSecond")}
            subtitle={<Stack direction={"row"} spacing={3}>
              <Box>
                <Stack direction={"row"} alignItems="flex-end">
                  <Box fontSize={16} fontWeight={700}>
                    {t("attachmentsvehicle.secondTitle.plate")}:&nbsp;
                  </Box>{" "}
                  <Box>{props.selectedAnVehicle.plate}</Box>
                </Stack>
              </Box>
              <Box>
                <Stack direction={"row"} alignItems="flex-end">
                  <Box fontSize={16} fontWeight={700}>
                    {t("attachmentsvehicle.secondTitle.vin")}:&nbsp;
                  </Box>{" "}
                  <Box>{props.selectedAnVehicle.vin}</Box>
                </Stack>
              </Box>
              <Box>
                <Stack direction={"row"} alignItems="flex-end">
                  <Box fontSize={16} fontWeight={700}>
                    {t("attachmentsvehicle.secondTitle.brand")}:&nbsp;
                  </Box>{" "}
                  <Box>{props.selectedAnVehicle.brand}</Box>
                </Stack>
              </Box>
              <Box>
                <Stack direction={"row"} alignItems="flex-end">
                  <Box fontSize={16} fontWeight={700}>
                    {t("attachmentsvehicle.secondTitle.model")}:&nbsp;
                  </Box>{" "}
                  <Box>{props.selectedAnVehicle.model}</Box>
                </Stack>
              </Box>{" "}
            </Stack>}
        />
      <Box>
        <Box border={"1px solid grey"} borderRadius={2} m={1.5} p={1}>
          <Stack direction="row" alignItems="center" gap={1}>
            <ArrowBackIcon
              fontSize="small"
              onClick={() => props.setOpenVehicleAttachment(false)}
            />
            <Typography variant="h5" color="#18305B">
              {t("attachmentsvehicle.title")}
            </Typography>
          </Stack>

          <Box bgcolor="white">
            {/* <CardContent>  */}
            <Box
              minHeight={46}
              pr={1}
              display="flex"
              justifyContent={"flex-end"}
              alignItems="center"
            >
              <Tooltip title={t("tooltipTitle.download")}>
                <IconButton
                  onClick={exportAttachmentVehicle}
                  color="accent"
                  disabled={length === 0 ? true : false}
                >
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("tooltipTitle.add")}>
                <IconButton
                  onClick={() => setOpenCreatModal(true)}
                  color="accent"
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <>
            <Box style={{ whiteSpace: "pre-line" }}>
              <AgGridOperationTable
                columnDefs={columnsDefs}
                onGridReady={onGridReady}
                cacheBlockSize={pageSize}
                serverSideInfiniteScroll={true}
                rowModelType={"serverSide"}
                totalElements={length}
                emptyState={{
                  title: t("attachmentsvehicle.noVehicleAttachmentTitle"),
                  content: t("attachmentsvehicle.noVehicleAttachmentContent")
                }}
              />

            </Box>
          </>
        </Box>
      </Box>
      {openModal && (
        <ConfirmationModalTransportator
          setOpen={openModal}
          onClose={() => setOpenModal(false)}
          title={t(
            "transportSupplierPriceList.promoIncreasesTable.deleteConfirmation"
          )}
          message={message}
          cancel={t("actionButtons.cancel")}
          confirm={t("actionButtons.delete")}
          updateAction={deleteAttachmentVehicle}
        />
      )}
      {openCreatModal && (
        <CreateVehicleAttachment
          setVehicleAttachment={setVehicleAttachment}
          vehicleAttachment={vehicleAttachment}
          vehicleId={vehicleId}
          setOpenCreatModal={setOpenCreatModal}
          createorEditVehicle={createorEditVehicleAttachment}
        />
      )}
      {/* {loading && <CustomLoader loading={loading} />} */}
    </>
  );
};
export default AttachmentsVehicle;
